<po-page-default
  [p-breadcrumb]="breadcrumb"
  p-title="Editar Romaneio"
>

  <div class="po-row">
    <po-widget
      class="po-md-12"
      (p-setting)="clickInformacoes()"
      p-title="Informações do Romaneio"
    >
      @if(apareceInformacoes){
        <div>
          <po-info class="po-md-3" p-label="Código" [p-value]="romaneio.CZ00COD"></po-info>
          <po-info class="po-md-3" p-label="Placa" [p-value]="romaneio.CZ00PLACA"></po-info>
          <po-info class="po-md-3" p-label="Usuário" [p-value]="romaneio.CZ00USER"></po-info>
          <po-info class="po-md-3" p-label="Nome Usuário" [p-value]="romaneio.CUSRNOME"></po-info>
          <po-info class="po-md-3" p-label="Local Origem" [p-value]="romaneio.CZ00ORIGEM"></po-info>
          <po-info class="po-md-3" p-label="Local Destino" [p-value]="romaneio.CZ00DESTIN"></po-info>
          <po-info class="po-md-3" p-label="Peso Caminhão" p-value="{{ romaneio.NZ00PESLIQ| number: '1.3-3' }}"></po-info>
        </div>
      }
    </po-widget>
  </div>

  @if((romaneio.CZ00STATUS == '0' && !soSalvar) || (romaneio.CZ00STATUS == 'A')){
    <po-input
      [p-auto-focus]="true"
      class="po-md-12"
      name="etiqueta"
      [(ngModel)]="etiqueta"
      p-label="Etiqueta"
      (keyup.enter)="biparEtiqueta()"
    ></po-input>
  }

  <h1 class="po-md-12 po-font-subtitle po-mb-1 po-mt-3">Etiquetas do Romaneio</h1>
  <div class="po-row">
    <po-table class="po-sm-12 po-md-12 po-lg-12"
      [p-striped]="true"
      [p-items]="romaneio.items"
      [p-columns]="colunas"
      p-spacing="small"
    ></po-table>
  </div>

  <div class="po-row">
    <po-button
      p-label="Salvar"
      class="po-xl-3 po-md-12 po-mt-2"
      (p-click)="modalFinalizarRomaneioOpen()"
      p-kind="primary"
    ></po-button>
    <po-button
      p-label="PDF Romaneio"
      class="po-xl-3 po-md-12 po-mt-2"
      (p-click)="getPDFRomaneio()"
      p-kind="secondary"
    ></po-button>
  </div>

</po-page-default>

<po-modal #salvarRomaneioModal p-title="Salvar Romaneio">

  <form #f="ngForm">
    <po-number
      class="po-md-12"
      name="nEtiquetas"
      [(ngModel)]="nEtiquetas"
      p-label="Número de Etiquetas Bipadas"
    ></po-number>
  </form>
  <po-button
    p-label="Validar Etiqueta e Avançar"
    class="po-xl-12 po-md-12 po-mt-2"
    (p-click)="confirmarAvancarRomaneio()"
    p-kind="primary"
  ></po-button>
  <po-button
    p-label="Apenas Salvar Romaneio"
    class="po-xl-12 po-md-12 po-mt-1"
    (p-click)="confirmarSalvarRomaneio()"
    p-kind="secondary"
  ></po-button>

  <po-modal-footer>
  </po-modal-footer>

</po-modal>
